<template>
  <div>
    <h2>Category</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div class="mb-3">
      Name TH
      <input-text-field
          :model="form.name_th"
          @update="form.name_th = $event"
      />
    </div>

    <div class="mb-3">
      Name EN
      <input-text-field
          :model="form.name_en"
          @update="form.name_en = $event"
      />
    </div>

    <div>
      Active
      <v-select
          :items="[{ text: 'Active', value: 1 }, { text: 'Inactive', value: 0 }]"
          background-color="#ffffff"
          item-text="text"
          item-value="value"
          menu-props="offsetY"
          outlined
          :value="form.active"
          @change="form.active = $event"
          style="border-radius: 30px; text-align: left!important;"
          dense
      ></v-select>
    </div>

    <div class="row text-right mt-5">
      <v-spacer></v-spacer>
      <cancel-button @click.native="onCancel" />
      <save-button @click.native="onSave" />
    </div>

  </div>
</template>

<script>
import Paginate from "@/components/Layout/Paginate"
import Loading from "vue-loading-overlay"
import IconPencil from "../../components/Icon/icon-pencil"
import InputTextField from "@/components/Input/InputTextField"
import CircleButton from "@/components/Button/CircleButton"
import moment from "moment"
import SaveButton from "@/components/Button/SaveButton"
import CancelButton from "@/components/Button/CancelButton"

export default {
  name: "SubscribeEmailTable",
  components: {
    Loading,
    Paginate,
    IconPencil,
    CircleButton,
    InputTextField,
    SaveButton,
    CancelButton
  },
  data () {
    return {
      moment,
      isLoading: false,
      form: {
        name_th: '',
        name_en: '',
        active: 1
      }
    }
  },
  async created() {
    if (this.$route.params.id) {
      let res = await this.$store.dispatch('SupportContact/getEnewsletterCategoryById', this.$route.params.id)
      console.log(res)
      this.form = res.result
    }
  },
  methods: {
    onCancel () {
      this.$router.push({ name: "EnewsletterCategories" })
    },
    async onSave () {
      this.isLoading = true
      let res
      if (this.$route.params.id) {
        this.form.id = this.$route.params.id
        res = await this.$store.dispatch('SupportContact/editEnewsletterCategory', this.form)
      } else {
        this.form.id = undefined
        res = await this.$store.dispatch('SupportContact/storeEnewsletterCategory', this.form)
      }
      if (res) {
        this.$router.push({ name: "EnewsletterCategories" })
      }
      this.isLoading = false
    }
  }
}
</script>

<style scoped>

</style>